import sidebarMarkUrl from "@/assets/brand/sidebar-collapsed-mark.svg";

export type MarkTone = "light" | "dark" | "mono";

interface Props {
  size?: number | string;
  /** Override width/height independently (e.g. the top bar's non-square 26×24). */
  width?: number | string;
  height?: number | string;
  className?: string;
  tone?: MarkTone;
}

export default function TaitoraMark({ size = 32, width, height, className, tone = "dark" }: Props) {
  const w = width ?? size;
  const h = height ?? size;
  // mono: inline SVG so currentColor inherits from CSS
  if (tone === "mono") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 56 48"
        fill="none"
        width={w}
        height={h}
        className={className}
        aria-label="Taitora"
        role="img"
      >
        <path d="M 5,48 V 24 A 20,20 0 0 0 25,4 H 54"             stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 8.5,48 V 24 A 16.5,16.5 0 0 0 25,7.5 H 50.5"  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 12,48 V 24 A 13,13 0 0 0 25,11 H 47"           stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 15.5,48 V 24 A 9.5,9.5 0 0 0 25,14.5 H 43.5"  stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <path d="M 19,48 V 24 A 6,6 0 0 0 25,18 H 40"             stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    );
  }

  // colored: loaded from src/assets/brand/sidebar-collapsed-mark.svg
  return (
    <img
      src={sidebarMarkUrl}
      width={w}
      height={h}
      className={className}
      alt="Taitora"
      draggable={false}
    />
  );
}
